module.exports = __webpack_public_path__ + "static/media/git.1fd0c2b9.svg";